export default __webpack_public_path__ + "static/media/O-147.a05ea0c1.png";